"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompiledFormulaExpression = void 0;
const FormulaInterpreter_1 = require("../interpreter/FormulaInterpreter");
const FormulaParser_1 = require("../parser/FormulaParser");
const FormulaTokenizer_1 = require("../tokenizer/FormulaTokenizer");
/**
 * Implementation of the CompiledExpression interface for formula expressions.
 * @class
 * @implements {CompiledExpression}
 */
class CompiledFormulaExpression {
    /**
     * Creates a new instance of CompiledFormulaExpression.
     * @param {string} expression - The formula expression to compile
     */
    constructor(expression) {
        this.expression = expression;
        this.type = "CompiledExpression";
        this._ast = new FormulaParser_1.FormulaParser().execute(new FormulaTokenizer_1.FormulaTokenizer().execute(expression));
    }
    /**
     * Evaluates the expression with the provided data.
     * @template T
     * @param {T} data - The data object to evaluate the expression against
     * @returns {string | number} The result of the evaluation
     */
    evaluate(data) {
        return new FormulaInterpreter_1.FormulaInterpreter().execute(this._ast, data);
    }
    /**
     * Returns the string representation of the expression.
     * @returns {string} The original expression string
     */
    toString() {
        return this.expression;
    }
}
exports.CompiledFormulaExpression = CompiledFormulaExpression;
